import React, { useEffect, useRef } from "react";
import SecondSection from "./components/SecondSection/SecondSection";
import ThirdSection from "./components/ThirdSection/ThirdSection";
import AppointmentForm from "./components/AppointmentForm/AppointmentForm";
import FirstSection from "./components/FirstSection/FirstSection";
import { useLocation } from "react-router-dom";

const Content = () => {
  const location = useLocation();
  const services = useRef(null);
  const appointmentForm = useRef(null);
  const reviews = useRef(null);
  const headerHeight = 100; 

  useEffect(() => {
    if (location.pathname === "/") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else if (location.pathname === "/servicii") {
      if (services.current) {
        const { top } = services.current.getBoundingClientRect();
        const offset = top + window.scrollY - headerHeight; 
        window.scrollTo({ top: offset, behavior: "smooth" }); 
      }
    } else if (location.pathname === "/recenzii") {
      if (reviews.current) {
        const { top } = reviews.current.getBoundingClientRect();
        const offset = top + window.scrollY - headerHeight; 
        window.scrollTo({ top: offset, behavior: "smooth" });
      }
    } else if (location.pathname === "/programare") {
      if (appointmentForm.current) {
        const { top } = appointmentForm.current.getBoundingClientRect();
        const offset = top + window.scrollY - headerHeight; 
        window.scrollTo({ top: offset, behavior: "smooth" });
      }
    }
  }, [location]);
  return (
    <>
      <FirstSection />
      <SecondSection ref={services} />
      <AppointmentForm ref={appointmentForm} />
      <ThirdSection ref={reviews} />
    </>
  );
};

export default Content;
